module.exports = __webpack_public_path__ + "assets/img/title-d9a3cae3.png";